if (!customElements.get('pdp-tabs')) {
    customElements.define('pdp-tabs', class PDPTabs extends HTMLElement {
        constructor() {
            super();
            this.pdp_tab_discount = this.querySelector('.pdp-tab__discount');
            this.toggles = Array.from(this.querySelectorAll('[class*="pdp-tabs__toggle-"]'));
            this.contents = Array.from(this.querySelectorAll('[class*="pdp-tab-"]'));

        }

        connectedCallback() {
            this.handleDiscountTables();
            this.addEventListeners();
        }

        addEventListeners() {
            this.addEventListener('trigger-technique-change', () => {
                this.handleDiscountTables(true);
                // this.handleTableContent();
            });
            if (this.toggles) {
                this.toggles.forEach(toggle => {
                    toggle.addEventListener('click', () => {
                        this.handleTabChange(toggle);
                    });
                });
            }
        }

        handleDiscountTables(update) {
            if (this.pdp_tab_discount) {
                let BULK_DISCOUNTS2 = JSON.parse(this.pdp_tab_discount.dataset.discount);
                let productTags = this.pdp_tab_discount.dataset.tags;
                let percentage = parseInt(this.pdp_tab_discount.dataset.percentage);
                let printDtfInfoBlock = this.querySelector('.pdp-tab__dtf-charges');
                let printDtgInfoBlock = this.querySelector('.pdp-tab__dtg-charges');

                let copyDiscountGroup;
                let newBreaks;

                BULK_DISCOUNTS2.forEach(discountGroup => {
                    copyDiscountGroup = { ...discountGroup };

                    if (productTags.includes(discountGroup.tag)) {
                        newBreaks = discountGroup.breaks.filter(breakItem => breakItem.percentage > percentage);

                        if (percentage !== 0 && (!newBreaks.length || newBreaks[0].percentage !== percentage)) {
                            newBreaks.unshift({
                                quantity: 1,
                                percentage: parseInt(percentage)
                            });
                        }
                        copyDiscountGroup.breaks = newBreaks;
                    }
                })

                let BULK_DISCOUNTS = [
                    {
                        name: copyDiscountGroup.name,
                        tag: copyDiscountGroup.tag,
                        breaks: copyDiscountGroup.breaks.map((item, index, arr) => {
                            const nextQuantity = arr[index + 1]?.quantity;

                            const quantityRange = nextQuantity
                                ? `${item.quantity}-${nextQuantity - 1}`
                                : `${item.quantity}+`;

                            return {
                                quantityRange,
                                percentage: item.percentage
                            };
                        })
                    }
                ];

                const discountTable = document.querySelector('.pdp-tab__table-values');
                if (update) {
                    discountTable.innerHTML = '';
                }
                const breaks = BULK_DISCOUNTS[0].breaks;

                breaks.forEach((breakItem, index) => {
                    const row = document.createElement('div');
                    if (index % 2 === 1) {
                        row.className = 'pdp-tab__table-row body-small pdp-tab__table-highlighted';
                    } else {
                        row.className = 'pdp-tab__table-row body-small';
                    }

                    const quantitySpan = document.createElement('span');
                    quantitySpan.textContent = breakItem.quantityRange || '';

                    const priceSpan = document.createElement('span');

                    let basePrice = parseFloat(this.pdp_tab_discount.dataset.price || "0");
                    basePrice = (Number(basePrice) / 100).toFixed(2);
                    let printPrice;
                    let currency = "€";
                    let technique = document.querySelector('.radio-btn:checked')?.value;

                    if (technique == 'DTG') {
                        printPrice = Number(this.pdp_tab_discount.dataset.price) + Number(this.pdp_tab_discount.dataset.basicPrint);
                        if (printDtgInfoBlock) {
                            printDtgInfoBlock.style.display = 'block';
                        }
                        if (printDtfInfoBlock) {
                            printDtfInfoBlock.style.display = 'none';
                        }
                    } else if (technique == 'DTF') {
                        printPrice = Number(this.pdp_tab_discount.dataset.price) + Number(this.pdp_tab_discount.dataset.print);
                        if (printDtgInfoBlock) {
                            printDtgInfoBlock.style.display = 'none';
                        }
                        if (printDtfInfoBlock) {
                            printDtfInfoBlock.style.display = 'block';
                        }
                    }

                    printPrice = (printPrice / 100).toFixed(2);
                    currency = this.pdp_tab_discount.dataset.currency || "€";

                    const discountedPriceItem = printPrice * (1 - breakItem.percentage / 100);

                    if (Shopify.country == "NL") {
                        priceSpan.textContent = `${currency} ${discountedPriceItem.toFixed(2)}`;
                    } else {
                        priceSpan.textContent = `${discountedPriceItem.toFixed(2)} ${currency}`;
                    }

                    const discountSpan = document.createElement('span');
                    discountSpan.className = 'pdp-tab__table-column3 pdp-tab__table-attention';
                    discountSpan.textContent = `${breakItem.percentage}%`;

                    row.appendChild(quantitySpan);
                    row.appendChild(priceSpan);
                    row.appendChild(discountSpan);

                    discountTable.appendChild(row);
                });
            }
        }

        handleTabChange(toggle) {
            const match = toggle.className.match(/pdp-tabs__toggle-(\d+)/);
            if (!match) return;

            const index = match[1];

            this.toggles.forEach(tog => {
                tog.classList.remove('pdp-tabs__toggle-active');
            })
            this.contents.forEach(tab => {
                tab.style.display = 'none';
            });

            toggle.classList.add('pdp-tabs__toggle-active');

            const targetTab = this.querySelector(`.pdp-tab-${index}`);
            if (targetTab) {
                targetTab.style.display = 'block';
            }
        }
    });
};
